import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts';
import { fetchStatusFechamento } from '../api/FechamentoApi';
import type { FechamentoCompetenciaPayload } from '../api/types';

export function useStatusFechamento(payload: FechamentoCompetenciaPayload | null) {
  const { toast } = useToast();
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  const query = useQuery({
    queryKey: [
      'status-fechamento-snac',
      cnpjGestor,
      payload?.CnpjContribuinte,
      payload?.Ano,
      payload?.Mes,
    ],
    queryFn: () => fetchStatusFechamento(payload!),
    enabled: !!payload && !!cnpjGestor,
    staleTime: 30_000,
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao consultar status da competência',
      description: 'Não foi possível carregar o status de fechamento. Tente novamente.',
    });
  }, [query.error, toast]);

  return query;
}
